import Container from '@mui/material/Container';

import AppDashboard from '../AppDashboard';
import ImpersonateProviderForm from '../../components/admin/ImpersonateProviderForm';

const AssumeProviderRolePage = () => {
  return (
    <AppDashboard>
      <Container maxWidth='xs' sx={{paddingTop: '2em'}}>
        <ImpersonateProviderForm />
      </Container>
    </AppDashboard>
  );
};

export default AssumeProviderRolePage;